#import "../fragments/user.gql"

query getCurrentUser {
  currentUser {
    ...userFragment
  }
}
